const DEFAULT_MAIN_API_URL = 'https://main.idkbr.com/v1'
const DEFAULT_MOMENTUM_API_URL = 'https://momentum.idkbr.com/v1'
const DEFAULT_GERO_URL = 'https://person.idkbr.com/person/static/files/gero.v2.9.1.min.js'
const DEFAULT_CHECK_GERO_API_URL = 'https://checker.idkbr.com/check-gero'
const DEFAULT_ANALYTICS_API_URL = 'https://analytics.idkbr.com/v1'
const DEFAULT_DCM_API_URL = 'https://dcmidkbr.com/v1'

const ENV_MAIN_API_URL = process.env.MAIN_API_URL ?? process.env.REACT_APP_MAIN_API_URL
const ENV_MOMENTUM_API_URL = process.env.MOMENTUM_API_URL ?? process.env.REACT_APP_MOMENTUM_API_URL

export const envConfig = {
    MAIN_API_URL: ENV_MAIN_API_URL ?? DEFAULT_MAIN_API_URL,
    MOMENTUM_API_URL: ENV_MOMENTUM_API_URL ?? DEFAULT_MOMENTUM_API_URL,
    GERO_URL: DEFAULT_GERO_URL,
    CHECK_GERO_API_URL: DEFAULT_CHECK_GERO_API_URL,
    ANALYTICS_API_URL: DEFAULT_ANALYTICS_API_URL,
    DCM_API_URL: DEFAULT_DCM_API_URL
}